export const COMMON_STATISTICS_SERVICES = {
	AMPLITUDE: 'Amplitude',
	INTERCOM: 'Intercom',
};
